import React from "react";

const ARModalWrapper = (props) => {
  const {control, children} = props;

  return (
    children.map((child) => (
      React.isValidElement(child) && React.cloneElement(child, {control})
    ))
  );
};

export default ARModalWrapper;